//Includes New Menu 2025 functions

import eToroMenu2025 from './menu-2025';
import mainHeaderSearch from './main-header-search';

mainHeaderSearch('.etoro-menu-2025');

document.addEventListener('DOMContentLoaded', eToroMenu2025);